import { Component, Input, Output, EventEmitter } from '@angular/core';
import {CommonModule} from '@angular/common';
import {LoadingSpinnerComponent} from '../ui/loading-spinner-component';
import {BaseButtonComponent} from './base-button.component';

@Component({
  standalone: true,
  imports: [CommonModule, LoadingSpinnerComponent, BaseButtonComponent],
  selector: 'app-plain-button',
  template: `
    <app-base-button
      [baseClass]="['w-full ' + bgColor + ' py-3 px-6 rounded-2xl flex items-center justify-between h-10', customClass].join(' ')"
      [disabled]="disabled"
      (onClick)="onClick.emit($event)"
    >
      <div class="flex justify-center w-full">
        <div class="flex flex-row items-center">
          <i *ngIf="icon" class="fas mr-2" [ngClass]="[color, icon, textSize]"></i>
          <span *ngIf="text" class="text" [ngClass]="[color, font, textSize]">{{ text }}</span>
        </div>
      </div>
    </app-base-button>
  `
})
export class PlainButtonComponent {
  @Input() text: string | undefined = undefined;
  @Input() textSize: string = 'text-xl';
  @Input() icon: string | undefined = undefined;
  @Input() font: string = 'font-bold';
  @Input() disabled: boolean = false;
  @Input() bgColor: string = 'bg-gray-200';
  @Input() color: string = 'text-theme-text';
  @Input() customClass: string = '';
  @Output() onClick = new EventEmitter<MouseEvent>();
}
